export const EVENT_NAME = {
  CONFIRM: "Bet Confirmed",
  ERROR: "Bet Error",
  SUCCESS: "Bet Successful"
};

export const MODULE = "Bet Modal"; // @TODO: confirm module name
export const EVENT_CATEGORY = "Bet";
